<template>
  <v-dialog
    lazy
    v-model="dialog"
    :max-width="options.width"
    @keydown.esc="cancel"
    v-bind:style="{ zIndex: options.zIndex }"
    :persistent="true"
    content-class="custom-dialog"
  >
    <v-card>
      <v-toolbar :color="options.color" dense flat>
        <!-- <v-toolbar-title class="white--text">{{ title || 'Confirm?' }}</v-toolbar-title> -->
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark flat @click="cancel">
            <v-icon color="#E0E0E0">close</v-icon>
          </v-btn>
        </v-toolbar-items>

      </v-toolbar>
      <p v-if="options.icon.default" class="custom-icon"><i class="material-icons warn-icon">error</i></p>
      <p v-else class = "custom-icon">
        <v-icon v-if = "alertType == 'error'" color="#FF9991">cancel</v-icon>
        <v-icon class="su" v-if = "alertType == 'success'" color="#3E67FB">check_circle_outline</v-icon>
      </p>
      <v-card-text class="blue-title" :class="alertType == 'error' || alertType == 'success' || alertType == 'default' ? 'align-center' : 'align-left' " v-show="!!message" v-html="message">{{ message }}</v-card-text>
      <div class="custom-footer">
        <v-btn v-if="options.cancelBtn.display" :disabled="submitting" :color="options.cancelBtn.color" class="text-none cancel-button" round @click.native="cancel">Cancel</v-btn>
        <v-btn v-if="options.confirmBtn.display" class="blue-button text-none confirm-button" :style="{'backgroundColor':(options.icon.default || alertType == 'error' || alertType == 'default')?'#FF9991 !important':''}"  @click.native="agree" :disabled="submitting" round>{{ submitting ? 'Submitting...': options.confirmBtn.text?options.confirmBtn.text:'Confirm'}}</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
/**
 * Vuetify Confirm Dialog component
 *
 * Insert component where you want to use it:
 * <confirm ref="confirm"></confirm>
 *
 * Call it:
 * this.$refs.confirm.open('Are you sure?', 'Delete', { color: 'red' }).then((confirm) => {})
 * Or use await:
 * if (await this.$refs.confirm.open('Are you sure?', 'Delete', { color: 'red' })) {
 *   // yes
 * }
 * else {
 *   // cancel
 * }
 *
 * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
 * <template>
 *   <v-app>
 *     ...
 *     <confirm ref="confirm"></confirm>
 *   </v-app>
 * </template>
 *
 * mounted() {
 *   this.$root.$confirm = this.$refs.confirm.open
 * }
 */
// code from https://gist.github.com/eolant/ba0f8a5c9135d1a146e1db575276177d
// 有改动, 增加了persistent选项可作为alert用
// 增加默认配置, 不传参的时候使用默认配置
// 调换了message 跟 title的位置, title增加默认值
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    alertType: null,
    options: {
      cancelBtn: {
        display: true,
        color: '#E0E0E0'
      },
      confirmBtn: {
        display: true,
        color: '#3e67fb'
      },
      icon: {
        default: true
      }
    },
    submitting: false
  }),
  methods: {
    open (message, alertType, options) {
      if (this.dialog === true) {
        console.error('不支持同时开启两个ConfirmDialog')
        return
      }
      this.dialog = true
      this.alertType = alertType || 'error' // 默认error，弹层不自动消失
      this.message = message
      this.param = options

      this.options = Object.assign({
        color: 'white',
        width: 400,
        zIndex: 200,
        awaitSubmit: false
      }, this.options, options)

      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree () {
      if (this.options.awaitSubmit) {
        // 当有提交时, 等待提交结束再关闭窗口
        new Promise((resolve, reject) => {
          this.submitting = true
          this.resolve({ result: true, submitcomplete: resolve })
        }).finally(submitcomplete => {
          this.submitting = false
          this.dialog = false
          this.options.awaitSubmit = false
        })
      } else {
        this.resolve(true)
        this.dialog = false
        this.submitting = false
      }
    },
    cancel () {
      if (this.options.awaitSubmit) {
        this.resolve({ result: false })
        this.options.awaitSubmit = false
      }
      this.resolve(false)
      this.dialog = false
    }
  },
  watch: {
    dialog (val) {
      if (!val || this.alertType !== 'success') return
      setTimeout(() => {
        this.cancel()
      }, 400000)
    }
  }
}
</script>
<style>
  .custom-dialog{
    border-radius: 8px;
    overflow: hidden;
  }
  .custom-dialog .theme--dark.v-btn{
    color: gray;
  }
  .custom-dialog .v-toolbar__content, .custom-dialog .v-toolbar__extension{
    padding: 0;
  }
  .custom-dialog .v-card__text{
    /* font-weight: bold; */
    font-size: 16px;
  }
  .custom-dialog .v-card__text.align-center{
    text-align: center;
  }
  .custom-dialog .v-card__text.align-left{
    text-align: left;
  }
  .custom-dialog .custom-icon{
    text-align: center;
    margin-bottom: 0;
  }
  .custom-dialog .custom-icon .v-icon{
    font-size: 40px;
    width: 40px;
    height: 40px;
    display: inline-block;
  }
  .warn-icon{
    font-size: 40px !important;
    color:#FF9991
  }
  .custom-dialog .custom-icon .v-icon.su{
    color: #1976d2
  }
  .custom-dialog .v-btn{
    padding: 0 !important;
  }
  .custom-dialog .custom-footer{
    text-align: center;
    padding: 10px 0 20px;
  }
  .custom-dialog .custom-footer .v-btn--outline{
    color: #000;
  }
  .confirm-button{
    height:28px !important;
    padding:0 !important;
  }
</style>
